import { Component } from "@angular/core";

@Component({
  selector: "page-nutri-exercicios",
  templateUrl: "nutri-exercicios.html",
})
export class NutriExerciciosPage {
  
}
